export class Language {
   constructor(
      public id: number,
      public code: string,
      public name: string
    ) { }
}
